import { createFileRoute, redirect } from '@tanstack/react-router';
import { RevenueSettings } from '@/components/settings/revenue-settings';
import { PageContent } from '@/components/page-content';
import { hasPermission } from '@/lib/permissions';

export const Route = createFileRoute(
  '/_auth/_side-layout/project-settings/revenue',
)({
  component: RevenueSettingsRoute,
  beforeLoad: ({ context }) => {
    // Stripe Connect + base currency are project-scoped, but connecting and
    // disconnecting Stripe is an org-admin capability on the backend — keep this
    // tab gated to org owners/admins even though it lives under Project Settings.
    if (!hasPermission(context.userRole, { organization: ['update'] })) {
      throw redirect({ to: '/project-settings/general' });
    }
  },
});

function RevenueSettingsRoute() {
  return (
    <PageContent>
      <RevenueSettings />
    </PageContent>
  );
}
